// In-memory cache for WebSocket query results, kept for the lifetime of the tab.
// Pages show the cached data instantly on reopen and refresh it in the background.
const cache = new Map();
const fetchedAt = new Map();

export const getCached = (key) => cache.get(key);

// when the cached data for `key` was stored (a Date), or null
export const getCachedAt = (key) => fetchedAt.get(key) || null;

export const setCached = (key, data) => {
  cache.set(key, data);
  fetchedAt.set(key, new Date());
};
